import { createCrudActions } from "../utils/crudGenerator";
import { axios } from "../connection/ConnectionHandler";
import { FETCH_NAVPRODUCTS } from "../constants";
import { API } from "../constants/api";

const formatRawmaterials = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.name}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchRawmaterials,
  create: createRawmaterial,
  update: updateRawmaterial,
  delete: deleteRawmaterials,
} = createCrudActions("RAWMATERIAL", "MateriaPrima", formatRawmaterials);

export const fetchNavProducts = () => async (dispatch) => {
  try {
    const response = await axios.get(API.rawmaterials.navProducts);
    if (response.status === 200 && response.data) {
      dispatch({ type: FETCH_NAVPRODUCTS, payload: response.data });
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
};
